// Cómo se ve el estado de un post en el calendario — ADR-2026-10-06-el-calendario-se-ve-como-instagram.
//
// Lo comparten la grilla de escritorio y el calendario del teléfono: un post tiene que
// tener el MISMO color y la misma miniatura en los dos.
//
// Tres colores y nada más (Buffer, Hootsuite): verde listo, ámbar le falta algo, rojo no se
// pudo publicar. Lo publicado va en gris: ya pasó y no pide nada.

import { Clapperboard, Copy, Image as ImagenIcono, Play } from 'lucide-react';
import CachedImg from '../../../components/CachedImg';
import { formatoDe, problemasDelPost, type PostDeRedes } from './post';
import type { PostConMiniaturas } from './postsApi';

export type Tono = 'listo' | 'falta' | 'publicado' | 'error';

export const TONOS: Record<Tono, { pildora: string; punto: string; chip: string; texto: string }> = {
  listo: {
    pildora: 'border-emerald-500 bg-emerald-50 hover:bg-emerald-100',
    punto: 'bg-emerald-500',
    chip: 'bg-emerald-50 text-emerald-700',
    texto: 'Listo',
  },
  falta: {
    pildora: 'border-amber-400 bg-amber-50 hover:bg-amber-100',
    punto: 'bg-amber-400',
    chip: 'bg-amber-50 text-amber-800',
    texto: 'Le falta algo',
  },
  publicado: {
    pildora: 'border-neutral-300 bg-neutral-100 hover:bg-neutral-200',
    punto: 'bg-neutral-400',
    chip: 'bg-neutral-100 text-neutral-600',
    texto: 'Publicado',
  },
  error: {
    pildora: 'border-red-500 bg-red-50 hover:bg-red-100',
    punto: 'bg-red-500',
    chip: 'bg-red-50 text-red-700',
    texto: 'No se publicó',
  },
};

export function tonoDe(p: PostDeRedes): Tono {
  if (p.estado === 'publicado' || p.estado === 'publicando') return 'publicado';
  if (p.estado === 'error') return 'error';
  return problemasDelPost(p).length > 0 ? 'falta' : 'listo';
}

export function IconoDeFormato({ post, className }: { post: PostDeRedes; className?: string }) {
  const f = formatoDe(post.medios);
  if (f === 'carrusel') return <Copy aria-label="Carrusel" className={className} />;
  if (f === 'reel') return <Clapperboard aria-label="Reel" className={className} />;
  return null;
}

/**
 * La portada del post. Sin piezas, un ícono de imagen apagado: antes mostraba el de "play",
 * y un post vacío se leía como un video sin póster.
 */
export function Miniatura({ post, icono = 'w-3 h-3' }: { post: PostConMiniaturas; icono?: string }) {
  if (post.miniaturas[0])
    return <CachedImg src={post.miniaturas[0]} alt="" className="h-full w-full object-cover" />;
  if (post.medios.length > 0) return <Play className={`${icono} text-neutral-400`} />;
  return <ImagenIcono className={`${icono} text-neutral-300`} />;
}
